import { CONFIG_ITEM_KEYS } from '../../config-items/config-item-keys';
export var isConfluenceTitleToolbarSuggestTitle = function isConfluenceTitleToolbarSuggestTitle(_ref) {
  var configItem = _ref.configItem,
    lastTriggeredFrom = _ref.lastTriggeredFrom;
  if (!configItem || !lastTriggeredFrom) {
    return false;
  }
  return configItem.key === CONFIG_ITEM_KEYS.SUGGEST_A_TITLE && lastTriggeredFrom === 'confluenceTitleToolbar';
};